import React, { useCallback, useEffect, useMemo, useState } from "react";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";

const ModalChecklist = ({ showChecklist, handleCloseChecklist, dataDisposisi, dataPrimer, jenisIzin, reloadList, isEdit }) => {
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    const [listChecklist, setListChecklist] = useState([])
    const [valueTglInspeksi, setValueTglInspeksi] = useState(null)
    const columns = [
        {
            name: 'Persyaratan',
            cell: row => (
                <div className="row">
                    <div className="col-12">
                        <b>{row['uraianChecklistHeader']}</b>
                    </div>
                    <div className="col-12">
                        &nbsp;&nbsp;&nbsp;&nbsp;{row['uraianCheckHeaderSub']}
                    </div>
                    <div className="col-12">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{row['uraianChecklistKomponen']}
                    </div>
                    <div className="col-12">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{row['uraianChecklistKomponenSub']}
                    </div>
                </div>
            )
        },
        {
            name: 'Nilai',
            cell: row => row['nilai'],
            grow: 0.1
        },
        {
            name: 'Keterangan',
            cell: row => (
                <div>
                    {row['nilai'] === 4 && 'Sesuai'}
                    {row['nilai'] === 3 && 'Minor'}
                    {row['nilai'] === 2 && 'Mayor'}
                    {row['nilai'] === 0 && 'Kritis'}
                </div>
            ),
            grow: 0.1
        }
    ]

    const fetchAllData = useCallback(async () => {
        if (!dataDisposisi?.idProses || !dataPrimer?.nomorAju || dataDisposisi.idDisposisi !== 7) {
            return
        }
        try {
            const resInspeksi = await pbumkuService.getUmkuInspeksiDataByAjuAndIdProses(dataPrimer.nomorAju, dataDisposisi.idProses)
            if (resInspeksi.data !== null) {
                setValueTglInspeksi(resInspeksi.data.tglInspeksi)
                const resChecklist = await pbumkuService.listUmkuChecklistByIdInspeksi(resInspeksi.data.idInspeksi)
                setListChecklist(resChecklist.data.data)
            }
        } catch (error) {

        }

    }, [pbumkuService, dataDisposisi, dataPrimer])

    useEffect(() => {
        let isMounted = true
        if (!dataPrimer) return

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [dataPrimer, fetchAllData])

    return (
        <>
            <Modal
                show={showChecklist}
                onHide={handleCloseChecklist}
                size="xl"
                centered
                scrollable
            >
                <Modal.Header><Modal.Title><h5>Checklist Inspeksi {jenisIzin}</h5></Modal.Title></Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPrimer?.nomorAju} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Inspeksi</Form.Label>
                                    <Col sm="4">
                                        <Form.Control type="date" placeholder="NIB" className="form-control-sm" value={valueTglInspeksi} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className="table-responsive border-bottom">
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                            columns={columns}
                            data={listChecklist}
                            highlightOnHover
                            pagination
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" size="sm" onClick={handleCloseChecklist}>Kembali</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ModalChecklist